module.exports = __webpack_public_path__ + "static/media/ugo_game_tex.89ccc4cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ugoGame/ugo_game_tex.png
// module id = 147
// module chunks = 0